import React, { useCallback } from 'react';
import { Button } from 'antd';
import { boundActions } from '../../../store';

export default function RemarkBtn(props) {

    const showRemarksModal = useCallback(() => {
        boundActions.getChangeRemarkAction({
            status: 'unfold'
        })
    }, []);
    
    return (
        <React.Fragment>
            <Button
                type="primary"
                ghost
                onClick={showRemarksModal}
                style={{ margin: '0 5px', borderColor: '#D3AF20', color: '#D3AF20' }}
                // size="small"
            >
                备注
            </Button>
        </React.Fragment>
    );
}
